import type { ReactNode } from 'react';

export enum AnimatedTilePhase {
    LOADING = 0,
    PLAYING = 1,
    FAILED = 2
}

export type AnimatedTileProps = {
    videoSrc: string;
    children: ReactNode;
    gameName: string;
    priority?: boolean;
};
